import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import LogoSvg from '../../svg/Logo.svg';

export interface LogoProps {
  className?: string;
}

const StyledLogo = styled(LogoSvg)`
  width: var(--logo-width);
  height: auto;
`;

const StyledWrapper = styled.div`
  margin: 0 auto;
  width: var(--logo-width);
`;

const Logo = ({ className }: LogoProps) => {
  return (
    <StyledWrapper className={className}>
      <Link to={'/'}>
        <StyledLogo />
      </Link>
    </StyledWrapper>
  );
};

export default Logo;
